import { Component } from '@angular/core';
import { ALERT_TYPE, Alert } from '../../../../../components/alert/alert.model';

@Component({
  selector: 'demo-alerts',
  templateUrl: './demo-alerts.component.html',
  styleUrls: ['./demo-alerts.component.scss'],
  standalone: false,
})
export class DemoAlertsComponent {
  alertPrimary: Alert = {
    isActive: true,
    title: 'Title',
    content: 'Incididunt culpa in anim aliqua id labore incididunt tempor.',
    containerClass: 'm-t-20',
    type: ALERT_TYPE.PRIMARY,
  };

  alertSuccess: Alert = {
    isActive: true,
    title: 'Title',
    content:
      'Adipisicing nisi ullamco aute dolore Lorem veniam enim consectetur in non laborum laborum. Culpa fugiat laborum cupidatat adipisicing dolor reprehenderit elit. Eu non incididunt tempor culpa voluptate ex pariatur sint aute occaecat enim deserunt. Do aliqua sit reprehenderit nostrud non est adipisicing cupidatat adipisicing. Commodo occaecat qui exercitation voluptate in ex magna officia labore minim magna. Deserunt culpa exercitation duis voluptate. Nostrud quis adipisicing ea amet quis nulla exercitation dolor.',
    containerClass: 'm-t-20',
    type: ALERT_TYPE.SUCCESS,
  };

  alertDanger: Alert = {
    isActive: true,
    title: 'Title',
    content: 'Incididunt culpa in anim aliqua id labore incididunt tempor.',
    containerClass: 'm-t-20',
    type: ALERT_TYPE.DANGER,
  };

  alertWarning: Alert = {
    isActive: true,
    title: 'Title',
    content: 'Incididunt culpa in anim aliqua id labore incididunt tempor.',
    containerClass: 'm-t-20',
    type: ALERT_TYPE.WARNING,
  };

  alertInfo: Alert = {
    isActive: true,
    title: 'Title',
    content: 'Incididunt culpa in anim aliqua id labore incididunt tempor.',
    containerClass: 'm-t-20',
    type: ALERT_TYPE.INFO,
  };
}
